import React from 'react'
import { FiTrendingUp } from 'react-icons/fi'
import HistoryPage from '../dashboardShell/HistoryPage'

const usd = (value) => `$${Number(value || 0).toLocaleString()} USD`

// Investment history (/investments)
const Investments = ({ route }) => (
  <HistoryPage
    route={route}
    topbarTitle="Investments"
    hero={{
      icon: <FiTrendingUp />,
      eyebrow: 'Investments',
      title: 'Investment history',
      description: 'Your investments and the profit each one has earned.',
    }}
    heroAside={(user) => (
      <div className="ud-hero-figure">
        <span>Total profit</span>
        <strong>${Number(user.totalprofit || 0).toLocaleString()}</strong>
      </div>
    )}
    sectionTitle="All investments"
    // `invest` is the user's investment list from getData
    getRows={(user) => user.invest}
    columns={[
      { label: 'Amount', render: (row) => usd(row.amount) },
      { label: 'Plan', render: (row) => row.plan },
      { label: 'Started', render: (row) => row.startDate },
      { label: 'Profit earned', render: (row, user) => user.periodicProfit ? usd(user.periodicProfit) : usd(0) },
      { label: 'Profit per day', render: (row) => usd(row.profit) },
    ]}
    emptyText="You haven't invested yet. Make a deposit to activate a plan."
    emptyAction={{ to: '/fundwallet', label: 'Make a deposit' }}
  />
)

export default Investments
